module.exports = __webpack_public_path__ + "img/No_image_available.ed67fb7c.svg";